module.exports = __webpack_public_path__ + "img/icon3.c5903a94.jpg";